import * as types from './action-types';
import { errorHandler } from '../../../utils/errors';
import CorporateQuoteApi from '../../../api/CorporateQuoteApi';

//TODO mofify actions wrt redux-promise-middleware-sriram
// quote steps

export const updateStep = step => ({ type: types.UPDATE_STEP, step });

export const setQuestionAnswer = (name, id, value) => ({
  type: types.SET_QUESTION_ANSWER,
  name,
  id,
  value,
});

export const clearQuestionAnswers = () => ({
  type: types.CLEAR_QUESTION_ANSWERS,
});

/** Fetch Quote Questions **/
export const fetchQuestions = () => ({
  type: types.FETCH_QUESTIONS,
  payload: CorporateQuoteApi.getQuestions(),
});

// Source Related actions
export const setCountry = country => ({
  type: types.SET_CQC_COUNTRY,
  value: country,
});

export const setCostCenter = costcenter => ({
  type: types.SET_CQC_COSTCENTER,
  value: costcenter,
});

export const setResCostCenter = resCostCenter => ({
  type: types.SET_CQC_RESCOSTCENTER,
  value: resCostCenter,
});

// fetch vehicles
export const fetchVehicles = sessionId => ({
  type: types.FETCH_VEHICLES,
  payload: CorporateQuoteApi.getVehiclesWithSession(sessionId).then(data => {
    if (!data.success) {
      throw data;
    }
    return data;
  }),
});

// action for user selection of vehicle
export const selectVehicle = (vehicle, terms) => ({
  type: types.SELECT_VEHICLE,
  vehicle,
  terms,
});

// quote options
export const fetchOptions = (quoteTemplateId, variantId) => ({
  type: types.FETCH_OPTIONS,
  payload: CorporateQuoteApi.getOptions(quoteTemplateId, variantId),
});

export const selectColour = selectedColour => ({
  type: types.SELECT_COLOUR,
  selectedColour,
});

export const selectExtra = (code, description) => ({
  type: types.SELECT_EXTRA,
  code,
  description,
});

export const deSelectExtra = (code, description) => ({
  type: types.DESELECT_EXTRA,
  code,
  description,
});

// quote delivery details
export const setDeliveryDetails = (
  DeliveryAddress,
  DeliveryState,
  DeliveryPostalCode,
  DeliverySuburb,
  CustomerContactPhone,
  CustomerName,
  DeliveryDate,
  ManualAddress
) => ({
  type: types.SET_DELIVERY_DETAILS,
  DeliveryAddress,
  DeliveryState,
  DeliveryPostalCode,
  DeliverySuburb,
  CustomerContactPhone,
  CustomerName,
  DeliveryDate,
  ManualAddress,
});

// fetch address
export const fetchAddresses = id => ({
  type: types.FETCH_ADDRESSES,
  payload: CorporateQuoteApi.getAddresses(id),
});

//fetch quote summary
export const fetchQuoteSummary = quoteId => ({
  type: types.FETCH_QUOTE_SUMMARY,
  payload: CorporateQuoteApi.getSummary(quoteId),
});

//export quote
export const exportQuote = quoteId => ({
  type: types.EXPORT_QUOTE,
  payload: CorporateQuoteApi.exportQuote(quoteId),
});

// Submit quote
export const submitQuote = quoteId => ({
  type: types.SUBMIT_QUOTE,
  payload: CorporateQuoteApi.submitQuote(quoteId),
});

export const setEstimatedCost = cost => ({
  type: types.SET_ESTIMATED_COST,
  cost,
});

export const setQuoteId = id => ({
  type: types.SET_QUOTE_ID,
  id,
});

// Update quote
export const updateQuote = quoteId => ({
  type: types.UPDATE_QUOTE,
  payload: CorporateQuoteApi.updateQuote(quoteId),
});

// quote lease details
export const setLeaseDetails = leaseDetails => ({
  type: types.SET_LEASE_DETAILS,
  ...leaseDetails,
});



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/actions.js